import React from 'react';
import { ADMIN_HEADER_OFFSET, EatsAdminHeader } from './EatsAdminLayout';

const EatsAppPageShell = ({ children, maxWidth = 1200, background = '#f2f4f8' }) => (
  <>
    <EatsAdminHeader />
    <div
      style={{
        paddingTop: ADMIN_HEADER_OFFSET + 24,
        paddingRight: 24,
        paddingBottom: 24,
        paddingLeft: 24,
        maxWidth,
        margin: '0 auto',
        background,
        minHeight: `calc(100vh - ${ADMIN_HEADER_OFFSET}px)`,
        boxSizing: 'border-box',
      }}
    >
      {children}
    </div>
  </>
);

export default EatsAppPageShell;
